import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { LearningStandard } from './@types';

export type ExternalTrainingModuleDraft = {
   external_training_moduleid: number;
   current_importid: number;
   draft_importid: number;
   title: string;
   source_name: string;
   source_type: 'URL' | 'FILE_UPLOAD';
   draft_updated_at: number;
   rustici_module_version_id: number;
   status: 'IMPORTING' | 'IN-ERROR' | 'PENDING-APPROVAL' | 'CURRENT';
   learning_standard: LearningStandard;
   import_error_message: string;
   usage_summary: {
      number_of_parent_associations: number;
      first_parent_title: string | null;
   };
};

export type GetExternalTrainingModulesDraftsResponse = {
   modules: ExternalTrainingModuleDraft[];
   hasMore: boolean;
};

export type GetExternalTrainingModulesDraftsSort = 'DESC' | 'ASC';

export const learningStandards = [
   'SCORM11',
   'SCORM12',
   'SCORM20042NDEDITION',
   'SCORM20043RDEDITION',
   'SCORM20044THEDITION',
   'AICC',
   'XAPI',
   'CMI5',
   'LTI11',
   'LTI13',
];

export type SortByOptions =
   | 'title'
   | 'learning_standard'
   | 'rustici_module_version_id'
   | 'draft_updated_at'
   | 'status';

export type GetExternalTrainingModulesDraftsFilters = {
   rustici_module_version_id?: number;
   learning_standard?: typeof learningStandards;
   status?: string[];
   draft_updated_at?: {
      from: number;
      to: number;
   };
};

export type GetExternalTrainingModulesDraftsOptions = CommonRequestOptions & {
   sortBy?: SortByOptions;
   sortDirection?: GetExternalTrainingModulesDraftsSort;
   limit?: number;
   offset?: number;
   searchTerm?: string;
   filters?: GetExternalTrainingModulesDraftsFilters;
};

export async function getExternalTrainingModulesDrafts({
   apiClient,
   onUploadProgress,
   ...body
}: GetExternalTrainingModulesDraftsOptions = {}): Promise<GetExternalTrainingModulesDraftsResponse> {
   return makeRequest('post', '/external-training-modules/drafts', {
      apiClient,
      onUploadProgress,
      body,
   });
}
